export default __webpack_public_path__ + "static/media/Grimjaw Bracers.419c3c5c.jpg";